document.addEventListener('turbolinks:load', () => {
  const dialIcon = document.querySelector('.layout-main > .dial-icon-wrapper');

  if (dialIcon) {
    window.addEventListener('scroll', () => {
      dialIcon.classList[window.scrollY > 90 ? 'add' : 'remove']('move-right');
    });
  }
});
